import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Box } from '@material-ui/core';

const filter = createFilterOptions({
  stringify: (option) => `${option.label} ${option.value}`,
});

const CustomAutocompleteImage = (props) => {
  const {
    label,
    name,
    className,
    classes,
    control,
    rule,
    options = [],
    error = {},
    disabled,
    required,
    styleFromHelperText,
    defaultValue,
    style,
    iconExpandMore,
    onChange: customOnChange,
  } = props;

  return (
    <FormControl
      className={className}
      style={style}
      fullWidth
    >
      <Controller
        name={name}
        control={control}
        rules={rule}
        defaultValue={defaultValue || null}
        render={({ onChange, value }) => {
          const currentOption = options.find((opt) => opt.value === value) || null;
          return (
            <Autocomplete
              id={`${name}-autocomplete`}
              options={options}
              disabled={disabled}
              className={classes}
              value={currentOption}
              filterOptions={filter}
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, val) => option.value === val.value}
              onChange={(event, newValue) => {
                const selectedValue = newValue ? newValue.value : null;
                onChange(selectedValue);
                if (customOnChange) {
                  customOnChange(selectedValue);
                }
              }}
              popupIcon={iconExpandMore || <ArrowDropDownIcon />}
              renderOption={(option) => (
                <Box display="flex" alignItems="center">
                  <Box
                    component="img"
                    src={option.image}
                    style={{
                      width: 16,
                      height: 12,
                      objectFit: 'cover',
                      borderRadius: 0.5,
                      marginRight: 8,
                    }}
                  />
                  <Box component="span">
                    {option.label}
                  </Box>
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  size="small"
                  variant="outlined"
                  required={required}
                  error={Boolean(error[name])}
                  helperText={error[name] ? error[name].message : null}
                  FormHelperTextProps={
                    styleFromHelperText || {
                      style: { margin: '0 0 0 5px', color: '#d61103' },
                    }
                  }
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: currentOption ? (
                      <Box
                        component="img"
                        src={currentOption.image}
                        style={{
                          width: 16,
                          height: 12,
                          objectFit: 'cover',
                          marginLeft: 8,
                          marginRight: 8,
                        }}
                      />
                    ) : null,
                  }}
                />
              )}
            />
          );
        }}
      />
    </FormControl>
  );
};

export default CustomAutocompleteImage;
